<prlw-table-column-content-ui
  [data]="columnData"
  [columnId]="columnId"
  [columnTypes]="columnTypes"
  [hasData]="hasData"
  [hasSecondData]="hasSecondData"
  [hasHighlight]="hasHighlight"
  [basisTrend]="basisTrend"
  [isOfferActive]="isOfferActive"
  [isLastDeal]="isLastDeal"
  [isOldDeal]="isOldDeal"
  [isLastQuote]="isLastQuote"
  [isOldQuote]="isOldQuote"
  [changesDirection]="changesDirection"
  [highlightChangesDirection]="highlightChangesDirection"
  [isDemandActive]="isDemandActive"
  [volumeDifference]="volumeDifference"
  [isTariffLoading]="isTariffLoading"
  [isTariffError]="isTariffError"
  [destination]="destination$ | async"
  [isDealTotal]="isDealTotal"
  [isDealTotalPrice]="isDealTotalPrice"
  [dealTime]="dealTime"
  [prevDealDate]="prevDealDate"
  [prevDealsAmountDiffDirection]="prevDealsAmountDiffDirection"
  [lastQuoteTime]="lastQuoteTime"
  [basisDetails]="basisDetails"
  [tariffDetails]="tariffDetails"
  [isHovered]="isHovered"
  [isActive]="isActive"
  [modifierType]="(modifier$ | async)?.type || null"
  [mode]="mode"
  [isEditor]="isEditor$ | async"
  [instrumentCode]="instrumentCode"
  (eventOpenEditTraderTariffOverlay)="handleOpenEditTraderTariffOverlay($event)"
></prlw-table-column-content-ui>
